import React, { useState, useEffect } from "react";
import { useTable } from "react-table";

import "./css/pure.css";
import "./css/table.css";

const LeagueOverviewTable = (props) => {
  const [nodes, setNodes] = useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Team Name",
        accessor: "team_name",
      },
      {
        Header: "Wins",
        accessor: "wins",
      },
      {
        Header: "Losses",
        accessor: "losses",
      },
      {
        Header: "Ties",
        accessor: "ties",
      },
      {
        Header: "Cat Wins",
        accessor: "total_wins",
      },
      {
        Header: "Cat Losses",
        accessor: "total_losses",
      },
      {
        Header: "Cat Ties",
        accessor: "total_ties",
      },
    ],
    []
  );

  const getData = async () => {
    try {
      const response = await fetch(`/get_win_loss/${props.league_id}/${props.week}`);
      const json = await response.json();
      setNodes(json.standings || []);
    } catch (error) {
      console.error("Error fetching standings:", error);
      setNodes([]);
    }
  };

  useEffect(() => {
    if (props.week) {
      getData();
    }
  }, [props.week]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: nodes });

  return (
    <table {...getTableProps()} className="pure-table">
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default LeagueOverviewTable;
